const partners = {
  DOCE_HORAS_ENVIOS: '12 horas',
  FAZT: 'fazt',
  STGO_COURIER: 'stgo courier'
}

const partnerLabels = {
  DOCE_HORAS_ENVIOS: '12 Horas Envíos',
  FAZT: 'Fazt',
  STGO_COURIER: 'Stgo Courier'
}

const partnerSelectOptions = [
  { text: partnerLabels.DOCE_HORAS_ENVIOS, value: partners.DOCE_HORAS_ENVIOS },
  { text: partnerLabels.FAZT, value: partners.FAZT },
  { text: partnerLabels.STGO_COURIER, value: partners.STGO_COURIER }
]

const partnerDeliveryStatusLabels = {
  [partners.DOCE_HORAS_ENVIOS]: {
    null: 'Retiro pendiente',
    assigned: 'Asignado',
    'in-transit': 'En transito',
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    partial: 'Parcial',
    cancelled: 'Cancelado'
  },
  [partners.FAZT]: {
    'Sin comuna': 'Sin comuna',
    Creado: 'Creado',
    'Etiqueta impresa': 'Etiqueta impresa',
    'En deposito': 'En deposito',
    'En ruta': 'En ruta',
    Completado: 'Completado',
    'No completado': 'No completado',
    Cancelado: 'Cancelado',
    Duplicado: 'Duplicado',
    'No aceptado': 'No aceptado',
    Siniestrado: 'Siniestrado',
    'En Devolución': 'En Devolución',
    Devuelto: 'Devuelto',
    'No Devuelto': 'No Devuelto',
    Retirado: 'Retirado'
  },
  [partners.STGO_COURIER]: {
    '0': 'A retirar',
    '1': 'A planta',
    '2': 'En camino',
    '5': 'Entregado',
    '6': 'Nadie',
    '7': 'A retirar',
    '8': 'Cancelado'
  }
}

export default {
  partners,
  partnerLabels,
  partnerSelectOptions,
  partnerDeliveryStatusLabels
}
